import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { IPermissionsState } from './permissions.reducer';
import * as fromReducer from './permissions.reducer';
import { TicketAttachmentDocumentType } from '../../../models/tickets/ticket-attachment-document-type.enum';

const getPermissionsState = createFeatureSelector<IPermissionsState>('permissions');

export const getPermissionsActionState = createSelector(
  getPermissionsState,
  fromReducer.getPermissionsActionState
);
export const getPermissions = createSelector(getPermissionsState, fromReducer.getPermissions);
export const getResidentAppSettings = createSelector(
  getPermissionsState,
  fromReducer.getResidentAppSettings
);

export const getTicketSettings = createSelector(getPermissionsState, fromReducer.getTicketSettings);

export const getDamageTicketFileTypes = createSelector(
  getTicketSettings,
  ticketSettings => ticketSettings.allowedDamageTicketAttachmentFileTypes
);

export const getConcernTicketFileTypes = createSelector(
  getTicketSettings,
  ticketSettings => ticketSettings.allowedConcernTicketAttachmentFileTypes
);

export const getDamageMessengerAvailability = createSelector(
  getTicketSettings,
  ticketSettings => ticketSettings.enableTicketMessengerForDamages
);

export const getConcernMessengerAvailability = createSelector(
  getTicketSettings,
  ticketSettings => ticketSettings.enableTicketMessengerForConcerns
);

export const getDamageTicketFileInputAccept = createSelector(
  getDamageTicketFileTypes,
  documentTypes => convertDocumentTypesToAcceptAttribute(documentTypes)
);

export const getConcernTicketFileInputAccept = createSelector(
  getConcernTicketFileTypes,
  documentTypes => convertDocumentTypesToAcceptAttribute(documentTypes)
);

const convertDocumentTypesToAcceptAttribute = (
  documentTypes: TicketAttachmentDocumentType[]
): string =>
  documentTypes
    .map(documentType => {
      if (documentType === TicketAttachmentDocumentType.IMG) {
        return 'image/*';
      }
      if (documentType === TicketAttachmentDocumentType.PDF) {
        return '.pdf';
      }
      return '';
    })
    .toString();
